import styled from 'styled-components';
import { Accordion as MuiAccordion } from '@mui/material';

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: start;
    justify-content: start;
    padding: 20px;
    border-radius: 10px;
    background-color: #fff;
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
    width: 600px;
`;

export const TitleContainer = styled.div`
    display: flex;
    justify-content: space-between;
    width: 100%;
    align-items: center;
`;

export const Title = styled.h2`
    font-size: 14px;
    font-weight: 600;
    margin-bottom: 4px;
`;

export const ButtonAddDepartment = styled.button`
    border: none;
    cursor: pointer;
    background-color: transparent;
`;


export const SearchContainer = styled.div`
  position: relative;
  margin-bottom: 8px;
  width: 100%;
`;

export const SearchInput = styled.input`
  width: 100%;
  padding: 8px 12px 8px 40px;
  background-color: #f0f2f5;
  border: none;
  border-radius: 8px;
  color: #111b21;
  font-size: 14px;
  transition: background-color 0.2s ease;
  margin-bottom: 10px;
  margin-top: 10px;
  &:focus {
    outline: none;
    background-color: #e4e6e8;
  }

  &::placeholder {
    color: #667781;
  }
`;

export const DepartmentList = styled.div`
    display: flex;
    flex-direction: column;
    align-items: start;
    justify-content: start;
    width: 100%;
    margin-bottom: 20px;
    overflow-y: auto;
`;
export const DepartmentItemContainer = styled.div`
    display: flex;
    align-items: center;
    width: 100%;
    justify-content: space-between;
`;

export const DepartmentItemContent = styled.div`
    display: flex;
    flex-direction: column;
    align-items: start;
    justify-content: space-between;
`;

export const DepartmentItemTitle = styled.span`
    font-size: 12px;
    font-weight: 600;
    margin-left: 10px;
    line-height: 12px;
`;

export const DepartmentItemSubtitle = styled.span`
    font-size: 12px;
    font-weight: 400;
    margin-left: 10px;
    line-height: 18px;
`;

export const DepartmentItemButton = styled.button`
  background-color: #ECEEF2;
  border-radius: 5px;
  font-size: 10px;
  font-weight: 600;
  padding: 5px 10px;
  border: none;
  cursor: pointer;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: #D9DCE0;
  }
`;

export const UserItemContainer = styled.div`
    display: flex;
    align-items: start;
    justify-content: start;
    width: 100%;
`;


export const UserItemText = styled.span`
  font-size: 12px;
  font-weight: 400;
  margin-left: 10px;
`;

export const StyledAccordion = styled( MuiAccordion )`
  width: 100%;
  &.MuiAccordion-root {
    border-bottom: none;
    box-shadow: none;
    
    &:before {
      display: none;
    }
    
    &.Mui-expanded {
      margin: 0;
    }
  }
  
  .MuiAccordionSummary-root {
    border-bottom: none;
    
    &:before {
      display: none;
    }
  }
`;

export const LoadingMessageContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px 16px;
  margin: 12px auto;
  width: 100%;
  height: 100%;
`;

export const LoadingMessage = styled.span`
  font-size: 11px;
  color: #667781;
  float: right;
  margin-left: 8px;
  margin-top: 4px;
`;




